import { useCallback } from "react";

import type * as Repository from "../../../_repository";

type Props = {
	options: Array<Repository.Query.QueryData.OptionPmsGetAvailableOptionList.Option>;
};

export const useHandleOption = ({ options }: Props) => {
	/**
	 * オプションを取得する
	 */
	const onGetOption = useCallback(
		(optionID?: string) => {
			return options.find(({ optionID: id }) => id === optionID);
		},
		[options],
	);

	/**
	 * サブオプションリストを取得する
	 */
	const onGetSubOptionList = useCallback(
		(option?: Repository.Query.QueryData.OptionPmsGetAvailableOptionList.Option) => {
			if (!option) return undefined;

			return option.subOptions;
		},
		[],
	);

	/**
	 * サブオプションを取得する
	 */
	const onGetSubOption = useCallback(
		(
			subOptionList?: Array<Repository.Query.QueryData.OptionPmsGetAvailableOptionList.SubOption>,
			selectedSubOptionID?: string,
		) => {
			if (!subOptionList) return undefined;

			return subOptionList.find(({ subOptionID: id }) => id === selectedSubOptionID);
		},
		[],
	);

	/**
	 * オプションの在庫数を取得する
	 */
	const onGetAvailableAmountOfOption = useCallback(
		(option?: Repository.Query.QueryData.OptionPmsGetAvailableOptionList.Option) => {
			if (!option) return undefined;

			return option.availableAmount;
		},
		[],
	);

	/**
	 * サブオプションの在庫数を取得する
	 */
	const onGetAvailableAmountOfSubOption = useCallback(
		(subOption?: Repository.Query.QueryData.OptionPmsGetAvailableOptionList.SubOption) => {
			if (!subOption) return undefined;

			return subOption.availableAmount;
		},
		[],
	);

	return {
		onGetOption,
		onGetSubOptionList,
		onGetSubOption,
		onGetAvailableAmountOfOption,
		onGetAvailableAmountOfSubOption,
	};
};
